import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  modalErrorTitle: {
    id: 'course-authoring.advanced-settings.modal.error.title',
    defaultMessage: 'Validation error while saving',
  },
  modalErrorButtonChangeManually: {
    id: 'course-authoring.advanced-settings.modal.error.btn.change-manually',
    defaultMessage: 'Change manually',
  },
  modalErrorButtonUndoChanges: {
    id: 'course-authoring.advanced-settings.modal.error.btn.undo-changes',
    defaultMessage: 'Undo changes',
  },
});

export default messages;
